export const targetOptions = {
  everywhere: 'everywhere',
  specific: 'specific',
  quick: 'quick',
};

export const getLocationOptionsMap = i18n => ({
  [targetOptions.quick]: {
    key: targetOptions.quick,
    text: i18n.getString(_TL_('United States')),
  },
  [targetOptions.everywhere]: {
    key: targetOptions.everywhere,
    text: i18n.getString(_TL_('All available countries/regions')),
  },
  [targetOptions.specific]: {
    key: targetOptions.specific,
    text: i18n.getString(_TL_('Let me choose specific locations')),
  },
});
